import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useOrderFormContext } from '../../OrderFormProvider';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ProjectionList from '../../ProjectionList';
import TotalsRow, { TotalsRowDescription } from '../../TotalsRow';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import translations from './translations';

const OrderTotalsFormSection = ({ fetchProjection }) => {
  const intl = useIntl();
  const { hasProjectionError, isFetchingProjection, projection } = useOrderFormContext();

  const handleRefreshProjection = () => {
    fetchProjection();
  };

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />

      {hasProjectionError && (
        <Alert
          severity="warning"
          action={
            <Button
              color="inherit"
              variant="outlined"
              size="small"
              onClick={handleRefreshProjection}
            >
              <FormattedMessage {...translations.buttons.refresh.label} />
            </Button>
          }
        >
          <FormattedMessage {...translations.projectionErrorMessage} />
        </Alert>
      )}

      {isFetchingProjection && (
        <CardContent>
          <TotalsRow>
            <TotalsRowDescription component="div">
              <SkeletonBody lines={1} />
            </TotalsRowDescription>
          </TotalsRow>
          <TotalsRow>
            <TotalsRowDescription component="div">
              <SkeletonBody lines={1} />
            </TotalsRowDescription>
          </TotalsRow>
          <TotalsRow>
            <TotalsRowDescription component="div">
              <SkeletonBody lines={1} />
            </TotalsRowDescription>
          </TotalsRow>
        </CardContent>
      )}

      {!isFetchingProjection && (
        <CardContent>
          <ProjectionList projection={projection} />
        </CardContent>
      )}
    </Card>
  );
};

OrderTotalsFormSection.propTypes = {
  fetchProjection: PropTypes.func,
};

OrderTotalsFormSection.defaultProps = {
  fetchProjection: undefined,
};

export default OrderTotalsFormSection;
